import React, { FC } from 'react'
import ArrowDownIcon from '@ucheba/ui/icons/icon__arrow-down.svg'

const SpecialitiesListIconMore: FC = () => {
  return (
    <ArrowDownIcon
      color='gray60'
      height='6px'
      width='6px'
      style={{ marginLeft: '-6px' }}
    />
  )
}

export { SpecialitiesListIconMore }
